module.exports = "https://cdn.realtymogul.com/static/media/Kyle_B.bbb349ce.jpg";